<template>
  <tour location="bottom right" title="Возможно вы хотите закрыть продажи по данной категории" max-width="485px">
    <template #text>
      <div class="paragraph-s_h text-secondary">
        Вы можете закрыть продажи настроив ограничение в разделе
        <router-link class="link" :to="{ name: RouteNames.TariffPricesAndRestrictions, query: { tab: 2 } }"
          >Ограничения ВР</router-link
        >
        или изменить <router-link class="link" :to="{ name: RouteNames.TariffQuota }">Квоту номеров</router-link>
      </div>
    </template>
  </tour>
</template>

<script setup lang="ts">
import Tour from '@/core/components/common/Tour.vue';
import { RouteNames } from '@/core/plugins/router/routeNames';
</script>
